import { useEffect, useState } from "react"
import { isPhoneScreen } from "@app/core/services/phone-screen-service"

function readPhoneScreen(): boolean {
  return isPhoneScreen({
    width: window.innerWidth,
    height: window.innerHeight,
    coarsePointer: window.matchMedia("(pointer: coarse)").matches,
  })
}

/** Whether the app is shown on a phone, followed when the screen turns or is resized. */
export function usePhoneScreen(): boolean {
  const [phoneScreen, setPhoneScreen] = useState<boolean>(readPhoneScreen)

  useEffect(() => {
    function update(): void {
      setPhoneScreen(readPhoneScreen())
    }
    window.addEventListener("resize", update)
    return () => window.removeEventListener("resize", update)
  }, [])

  return phoneScreen
}
